export default "__VITE_ASSET__Dot1RH2T__"